import { createFileRoute, redirect } from "@tanstack/react-router";

// Duplicate of /conveyancing/redcliffe — the two split the "conveyancing redcliffe" signal
// between them, so this one folds into the suburb page that carries the fees, reviews and
// short-answer block.
export const Route = createFileRoute("/redcliffe-conveyancing")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing/redcliffe", statusCode: 301 });
  },
});
